import { render, staticRenderFns } from "./list_manage_button.vue?vue&type=template&id=0f752b77&"
import script from "./list_manage_button.vue?vue&type=script&lang=js&"
export * from "./list_manage_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports